// extracted by mini-css-extract-plugin
export default {"album":"album_album__Syj36","album_heading":"album_album_heading__D3k7L"};